import { Collapse } from '@material-ui/core';
import { useEffect } from 'react';

import { AutoLoanPaymentHeaderComponent } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/PaymentMethodHeader/components/AutoLoanPaymentHeaderComponent';
import { withPaymentMethodCardWrapper } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/PaymentMethodWrapper';
import { usePaymentMethodCardConfiguration } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/usePaymentMethodCardConfiguration';
import { AutoSimulator } from '@/components/modules/Application/components/PaymentMethod/AutoLoan/components/PaymentMethodCard/AutoSimulator';
import { AutoLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/AutoLoan/entities/PaymentMethod/AutoLoanPaymentMethod';

interface AutoLoanPaymentMethodCardProps {
  paymentMethodEntity: AutoLoanPaymentMethod;
}

export const AutoLoanPaymentMethodCard = ({ paymentMethodEntity }: AutoLoanPaymentMethodCardProps) => {
  const { isConfigurationOpen, toggleConfiguration } = usePaymentMethodCardConfiguration(paymentMethodEntity);

  useEffect(() => {
    toggleConfiguration();
  }, []);

  return (
    <>
      <AutoLoanPaymentHeaderComponent
        paymentMethodEntity={paymentMethodEntity}
        isConfigurationOpen={isConfigurationOpen}
        toggleConfiguration={toggleConfiguration}
        hasLenders
      />
      <Collapse in={paymentMethodEntity.isSelected} style={{ borderBottom: 'none' }}>
        <AutoSimulator paymentMethodEntity={paymentMethodEntity} />
      </Collapse>
    </>
  );
};

export const AutoLoanPaymentMethodCardWithWrapper = withPaymentMethodCardWrapper(AutoLoanPaymentMethodCard);
